import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { OktaAuthStateService, OKTA_AUTH } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
import { Observable } from 'rxjs';
import { AuthService } from '../../../services/auth.service';
import { OKTAService } from '../services/okta.service';
import packageJson from '../../../../../../../package.json';

@Component({
  selector: 'app-jabil',
  templateUrl: './jabil.component.html',
  styleUrls: ['./jabil.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class JabilComponent implements OnInit {

  cookiesAllowed: boolean | undefined = undefined;
  title = 'okta';
  public isAuthenticated$!: Observable<boolean>;
  version: string = '0';

  constructor(public authStateService: OktaAuthStateService, @Inject(OKTA_AUTH) private oktaAuth: OktaAuth, private oktaService: OKTAService, private authService: AuthService) {
    this.version = packageJson.version;
  }

  async ngOnInit(): Promise<void> {

    window.addEventListener("message", async (evt: any) => {

      if (evt.data === 'MM:3PCunsupported') {
        this.cookiesAllowed = false;
      } else if (evt.data === 'MM:3PCsupported') {
        this.cookiesAllowed = true;
        await this.oktaAuth.signInWithRedirect({ originalUri: '/account/okta/auth' }).catch(error => console.log(error));
      }

    }, false);

  }



}
